import Home from './views/Home';
import BecomeAPartner from './views/BecomeAPartner';
import PartnerForm from './views/BecomeAPartner/Form';
import Account from './views/Account';
import Discounts from './views/Discounts';
import Download from './views/Download';
//import SignUp from './views/SignUp';
import SignUp from './views/Auth/SignUp';
import SignUpSetPassword from './views/Auth/SignUpSetPassword';
import Login from './views/Auth/Login';
import Forgot from './views/Auth/Forgot';
import AboutUs from './views/AboutUs';
import Membership from './views/Membership';
import FAQ from './views/PublicPages/FAQ';
import TermsAndConditions from './views/PublicPages/TermsAndConditions';
import TerminationOfAccount from './views/PublicPages/TerminationOfAccount';
import MembershipTermsConditions from './views/PublicPages/MembershipTermsConditions';
import PrivacyPolicy from './views/PublicPages/PrivacyPolicy';
import Giveaways from './views/Giveaways';
import Support from './views/Support';
import OneTimePaymentSuccess from './views/OneTimePayment/success';
import OneTimePaymentFailed from './views/OneTimePayment/failed';
import GiveawaysDailyWheel from './views/Giveaways/components/DailyWheel';
import Referrer from './views/Referrer';
import Portal from './views/Portal';

import { HomeIcon, AccountIcon } from './components/Icons/Icons';

export const main = [
  {
    path: '/',
    name: 'Home',
    icon: <HomeIcon color="inherit" />,
    component: Home,
    layout: '/',
  },
  {
    path: 'membership',
    name: 'Membership',
    icon: <HomeIcon color="inherit" />,
    component: Membership,
    layout: '/',
  },
  {
    path: 'faqs',
    name: 'Terms & Conditions',
    icon: <HomeIcon color="inherit" />,
    component: FAQ,
    layout: '/',
  },
  {
    path: 'terms-and-conditions',
    name: 'Terms & Conditions',
    icon: <HomeIcon color="inherit" />,
    component: TermsAndConditions,
    layout: '/',
  },
  {
    path: 'termination-of-account',
    name: 'Termination Of Account',
    icon: <HomeIcon color="inherit" />,
    component: TerminationOfAccount,
    layout: '/',
  },
  {
    path: 'privacy-policy',
    name: 'Privacy Policy',
    icon: <HomeIcon color="inherit" />,
    component: PrivacyPolicy,
    layout: '/',
  },
  {
    path: 'membership-terms-conditions',
    name: 'Membership Terms Conditions',
    icon: <HomeIcon color="inherit" />,
    component: MembershipTermsConditions,
    layout: '/',
  },
  {
    path: 'contact-support',
    name: 'Contact Support',
    icon: <HomeIcon color="inherit" />,
    component: Support,
    layout: '/',
  },
  {
    path: 'partner-with-us',
    name: 'Partner with us',
    icon: <HomeIcon color="inherit" />,
    component: PartnerForm,
    layout: '/',
  },
  {
    path: '/one-time-payment-success',
    name: 'Success One Time Payment',
    icon: <HomeIcon color="inherit" />,
    component: OneTimePaymentSuccess,
    layout: '/clear',
  },
  {
    path: '/one-time-payment-failed',
    name: 'Failed One Time Payment',
    icon: <HomeIcon color="inherit" />,
    component: OneTimePaymentFailed,
    layout: '/clear',
  },
  {
    path: '/',
    name: 'Portal',
    icon: <HomeIcon color="inherit" />,
    component: Portal,
    layout: '/portal',
  },
  {
    path: '/',
    name: 'Daily Wheel',
    icon: <HomeIcon color="inherit" />,
    component: GiveawaysDailyWheel,
    layout: '/giveaways/daily/wheel',
  },
  {
    path: 'download',
    name: 'Download',
    icon: <HomeIcon color="inherit" />,
    component: Download,
    layout: '/',
  },
  {
    path: 'referrer',
    name: 'Referrer',
    icon: <HomeIcon color="inherit" />,
    component: Referrer,
    layout: '/',
  },
];

export const header = [
  {
    name: 'Explore',
    category: 'header',
    state: 'pageHeader',
    views: [
      {
        path: 'become-a-partner',
        name: 'Become a Partner',
        icon: <HomeIcon color="inherit" />,
        component: BecomeAPartner,
        layout: '/',
      },
      {
        path: 'about',
        name: 'About',
        icon: <HomeIcon color="inherit" />,
        component: AboutUs,
        layout: '/',
      },
    ],
  },
  {
    path: 'discounts',
    name: 'Discounts',
    icon: <HomeIcon color="inherit" />,
    component: Discounts,
    layout: '/',
  },
  /*{
    path: 'previous-winners',
    name: 'Previous winners',
    icon: <HomeIcon color="inherit" />,
    component: Giveaways,
    layout: '/',
  },*/
  {
    path: 'giveaways',
    name: 'Giveaways',
    icon: <HomeIcon color="inherit" />,
    component: Giveaways,
    layout: '/',
  },
];

export const auth = [
  {
    path: '/sign-up',
    name: 'Sign Up',
    icon: <HomeIcon color="inherit" />,
    component: SignUp,
    layout: '/auth',
  },
  {
    path: '/login',
    name: 'Login',
    icon: <HomeIcon color="inherit" />,
    component: Login,
    layout: '/auth',
  },
  {
    path: '/forgot',
    name: 'Forgot Password',
    icon: <HomeIcon color="inherit" />,
    component: Forgot,
    layout: '/auth',
  },
  {
    path: '/set-password',
    name: 'Sign Up',
    icon: <HomeIcon color="inherit" />,
    component: SignUpSetPassword,
    layout: '/auth',
  }
];

export const account = [
  {
    path: 'account',
    name: 'Account',
    icon: <AccountIcon color="inherit" />,
    component: Account,
    layout: '/',
  },
];

const routes = [...main, ...header, ...auth, ...account];
export default routes;
